import { render, staticRenderFns } from "./UserStatList.vue?vue&type=template&id=54697af1&scoped=true"
import script from "./UserStatList.vue?vue&type=script&lang=js"
export * from "./UserStatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54697af1",
  null
  
)

export default component.exports